import { Component, ElementRef, ViewChild } from '@angular/core';
import { SharedModule } from 'src/app/modules/shared.module';
import { RulesService } from 'src/app/services/api/rules.service';
import { ScrollService } from 'src/app/services/scroll.service';
import { CategoriesPageComponent } from "../categories-page/categories-page.component";
import { TermsAndConditionsModalComponent } from '../modals/terms-and-conditions-modal/terms-and-conditions-modal.component';

@Component({
  selector: 'app-home-page',
  imports: [
    SharedModule,
    CategoriesPageComponent,
    TermsAndConditionsModalComponent
  ],
  templateUrl: './home-page.component.html',
  styleUrl: './home-page.component.scss'
})
export class HomePageComponent {

  @ViewChild('categoriesRef', { static: false }) categoriesRef!: ElementRef;


  public showBulgariBackground: boolean = true;
  public readonly backgroundStyle: any = {
    'position': 'relative',
    'background-attachment': 'fixed'
  };

  constructor(
    public readonly scrollService: ScrollService,
    public readonly rulesService: RulesService,
  ) { }

}
